import { Component } from '@angular/core';

@Component({
  selector: 'app-kyc-solution',
  templateUrl: './kyc-solution.component.html',
  styleUrls: ['./kyc-solution.component.css']
})
export class KycSolutionComponent {

  ShowCard:any;
  
}
